import { faBell } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";

export const CustomToast = ({ message }) => {
  return (
    <div className="flex flex-row items-center text-white w-[300px] p-4">
      <div className="flex text-xl mr-3 items-center">
        <FontAwesomeIcon className="inline" icon={faBell} />
      </div>
      <div className="flex items-center">{message}</div>
    </div>
  );
};

export const alert = (type, message) => {
  switch (type) {
    case "warning":
      return toast.warning(<CustomToast message={message} />, {
        autoClose: 5000,
      });
    case "error":
      return toast.error(<CustomToast message={message} />, {
        autoClose: false,
      });
    case "success":
      return toast.success(<CustomToast message={message} />);
    case "info":
      return toast.info(<CustomToast message={message} />, {
        closeOnClick: false,
        autoClose: 10000,
      });
    case "note-attachment":
      return toast.info(<CustomToast message={message} />, {
        closeOnClick: false,
        autoClose: false,
        toastId: "note-attachment",
      });
    case "dark":
      return toast(<CustomToast message={message} />, {
        theme: "dark",
      });
    default:
      return toast(<CustomToast message={message} />);
  }
};
